/* FR Makeover – Hautanliegen & Produktart nach Routine-Finder-Logik (sections/fr-hautziel.liquid)
   Datenquelle: dieselbe Liste wie der Routine-Finder (snippets/skin-analysis-attributes.liquid → productAttributes).
   Keine Tags, kein Metafeld „hautprobleme“.

   Regeln (wie der Routine-Finder):
   - Rang je Anliegen und Produktart, 1 = am besten. 18/19/20 = nicht geeignet.
   - Reihenfolge: Rang aufsteigend; bei gleichem Rang zuerst der Schritt, den der Routine-Finder als Hauptprodukt nimmt
     (HERO_STEP), dann Cleanser, Serum, Tag, Nacht, Auge, Maske, Peeling, Extras.
   - „Sensible Haut“: Rang bei Rötungen/Sensibilität, ohne Produkte, die der Routine-Finder bei „sehr sensibler Haut“ ausschließt.
   Hautanliegen-Seite: alle geeigneten Produkte aus „Alle Produkte“ (geladen über sections/fr-rf-pool.liquid), danach
     Produkte der Kollektion ohne Routine-Finder-Daten (z. B. Sets), damit nichts verschwindet.
   Produktart-Seite: ohne Chip alle Produkte der Kollektion; Chip „Hautanliegen“ = nur geeignete, nach Rang sortiert. */
(function (run) {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})(function () {
  var root = document.querySelector('[data-fr-rf]');
  if (!root || typeof productAttributes === 'undefined') return;

  /* Seite → Routine-Finder-Anliegen [Anliegen, Ausschluss]. Elastizitätsverlust vorerst ohne Zuordnung. */
  var PAGES = {
    'unreinheiten': ['acne'],
    'porengrosse': ['shinyAndPores'],
    'rotungen-und-rosazea': ['redness'],
    'sensible-haut': ['redness', 'sensitive'],
    'trockene-haut': ['dehydration'],
    'anti-aging': ['aging'],
    'pigmentierung': ['pigmentation']
  };
  /* Chip-Beschriftung (Metafeld produktart_ziele) → Anliegen */
  var LABELS = {
    'unreinheiten': ['acne'], 'akne': ['acne'],
    'porengröße': ['shinyAndPores'], 'poren': ['shinyAndPores'], 'glänzende/fettige haut': ['shinyAndPores'],
    'rötungen': ['redness'], 'rötungen & rosazea': ['redness'], 'rötungen und rosazea': ['redness'], 'rosazea': ['redness'],
    'sensible haut': ['redness', 'sensitive'],
    'trockene haut': ['dehydration'], 'dehydrierte haut': ['dehydration'],
    'anti-aging': ['aging'], 'falten': ['aging'],
    'pigmentierung': ['pigmentation'], 'pigmentflecken': ['pigmentation']
  };
  var HERO_STEP = { acne: 'serum', shinyAndPores: 'serum', pigmentation: 'serum', aging: 'serum', redness: 'night', dehydration: 'night' };
  var ORDER = ['cleanser', 'serum', 'day', 'night', 'eye', 'masque', 'peel', 'add-on', 'body', 'neck', 'lip', 'nutrition', 'any'];
  var TYPE_LABEL = { cleanser: 'Cleanser', serum: 'Serum', day: 'Tagespflege', night: 'Nachtpflege', eye: 'Augenpflege', masque: 'Maske', peel: 'Peeling', 'add-on': 'Extras', body: 'Körper', neck: 'Hals', lip: 'Lippen' };
  var NOT_SUITABLE = 18;

  var ATTR = {};
  productAttributes.forEach(function (a) { ATTR[String(a.variantId)] = a.variantAttributes; });

  function attrOf(li) {
    var ids = (li.getAttribute('data-vids') || '').split(',');
    for (var i = 0; i < ids.length; i++) { if (ATTR[ids[i]]) return ATTR[ids[i]]; }
    return null;
  }
  /* Rang für ein Anliegen, null = nicht geeignet / keine Daten */
  function rankOf(at, rule) {
    if (!at || !at.skinConcerns) return null;
    var r = at.skinConcerns[rule[0]];
    if (typeof r !== 'number' || r >= NOT_SUITABLE) return null;
    if (rule[1] && at.contraIndications && at.contraIndications[rule[1]]) return null;
    return r;
  }
  /* größter vergebener Rang je Anliegen und Produktart (ohne 18–20). „Besser geeignet“ = obere Hälfte, z. B. Cleanser-Rang 1–5 von 10 */
  var MAXR = {};
  productAttributes.forEach(function (a) {
    var v = a.variantAttributes; if (!v || !v.skinConcerns) return;
    Object.keys(v.skinConcerns).forEach(function (c) {
      var r = v.skinConcerns[c]; if (typeof r !== 'number' || r >= NOT_SUITABLE) return;
      var k = c + '|' + v.type; if (!MAXR[k] || r > MAXR[k]) MAXR[k] = r;
    });
  });
  function bestRankOf(at, rule) {
    var r = rankOf(at, rule); if (r === null) return null;
    var mx = MAXR[rule[0] + '|' + at.type] || r;
    return r <= Math.ceil(mx / 2) ? r : null;
  }
  /* kurzer Hinweis über den Produkten + „Sortiert nach“ */
  var sortLbl = root.querySelector('[data-fr-rf-sortlabel]');
  var sortTxt = sortLbl ? sortLbl.textContent : '';
  var pageTitle = (document.querySelector('.fr-hz-hero__title') || {}).textContent || '';
  var hint = document.createElement('p');
  hint.className = 'fr-rf-hint'; hint.hidden = true;
  (function () { var g = root.querySelector('[data-fr-rf-grid]'); if (g && g.parentNode) g.parentNode.insertBefore(hint, g); })();
  function showHint(txt) { hint.textContent = txt || ''; hint.hidden = !txt; }
  function sortByRank(list, rule) {
    var hero = HERO_STEP[rule[0]];
    var order = [hero].concat(ORDER.filter(function (t) { return t !== hero; }));
    return list.slice().sort(function (a, b) {
      if (a.r !== b.r) return a.r - b.r;
      var ia = order.indexOf(a.at.type), ib = order.indexOf(b.at.type);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib) || a.i - b.i;
    });
  }
  function keyOf(li) { var a = li.querySelector('.fr-s-title'); return a ? a.getAttribute('href').split('?')[0] : ''; }

  var grids = root.querySelectorAll('[data-fr-rf-grid]');
  var countEl = root.querySelector('[data-fr-rf-count]');

  /* ===================== Produktart: Chips filtern die vorhandenen Produkte ===================== */
  if (root.getAttribute('data-fr-rf') === 'produktart') {
    var items = [];
    grids.forEach(function (g) { [].forEach.call(g.children, function (li) { items.push({ li: li, at: attrOf(li), i: items.length }); }); });
    var restSec = root.querySelector('[data-fr-rf-rest]');
    var chips = root.querySelectorAll('[data-fr-rf-chip]');
    var total = items.length;
    function apply(rule) {
      var first = grids[0], second = grids[1], split = parseInt(root.getAttribute('data-split') || '8', 10);
      var list;
      if (!rule) list = items.slice();
      else list = sortByRank(items.map(function (x) { return { li: x.li, at: x.at, i: x.i, r: bestRankOf(x.at, rule) }; }).filter(function (x) { return x.r !== null; }), rule);
      items.forEach(function (x) { if (x.li.parentNode) x.li.parentNode.removeChild(x.li); });
      list.forEach(function (x, k) { ((k < split || !second) ? first : second).appendChild(x.li); });
      if (restSec) restSec.hidden = list.length <= split;
      if (countEl) countEl.textContent = list.length;
      /* Mit Chip zählt nur die Routine-Finder-Bewertung: Sortierung (z. B. „Meistverkauft“) ausblenden */
      if (sortBox) sortBox.hidden = !!rule;
      if (sortLbl) { sortLbl.textContent = rule ? 'Sortiert nach: Routine-Finder-Empfehlung' : sortTxt; sortLbl.hidden = false; }
      showHint(rule ? 'Wie im Routine-Finder: Hier siehst du nur die ' + pageTitle.trim() + '-Produkte, die bei „' + label + '“ am besten abschneiden – das beste zuerst. Dieselbe Bewertung wie in deiner Hautanalyse.' : '');
    }
    var sortBox = root.querySelector('.fr-s-sort');
    var label = '';
    chips.forEach(function (c) {
      var rule = LABELS[(c.getAttribute('data-fr-rf-chip') || '').toLowerCase()];
      if (!rule) { c.hidden = true; return; }
      var n = items.filter(function (x) { return bestRankOf(x.at, rule) !== null; }).length;
      var small = c.querySelector('small'); if (small) small.textContent = n;
      if (!n) { c.hidden = true; return; }
      c.addEventListener('click', function (e) {
        e.preventDefault();
        var on = !c.classList.contains('is-on');
        chips.forEach(function (o) { o.classList.remove('is-on'); o.setAttribute('aria-pressed', 'false'); });
        if (on) { c.classList.add('is-on'); c.setAttribute('aria-pressed', 'true'); }
        label = c.getAttribute('data-fr-rf-chip');
        apply(on ? rule : null);
        var bar = document.getElementById('produkte'); if (bar && on) bar.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    if (countEl) countEl.textContent = total;
    return;
  }

  /* ===================== Hautanliegen: geeignete Produkte aus „Alle Produkte“ ===================== */
  var rule = PAGES[root.getAttribute('data-collection')];
  if (!rule) return;
  var poolUrl = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'collections/' + (root.getAttribute('data-fr-rf-pool') || 'alle-produkte') + '?section_id=fr-rf-pool';
  var own = [];
  grids.forEach(function (g) { [].forEach.call(g.children, function (li) { own.push(li); }); });

  fetch(poolUrl).then(function (r) { return r.ok ? r.text() : Promise.reject(); }).then(function (html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var pool = [].slice.call(doc.querySelectorAll('[data-fr-rf-pool] > li'));
    if (!pool.length) return;
    var seen = {}, ranked = [];
    pool.forEach(function (li, i) {
      var at = attrOf(li), r = rankOf(at, rule);
      if (r === null) return;
      seen[keyOf(li)] = true;
      ranked.push({ li: document.importNode(li, true), at: at, r: r, i: i });
    });
    ranked = sortByRank(ranked, rule);
    /* Produkte der Kollektion ohne Routine-Finder-Daten (Sets, neue Produkte) ans Ende */
    var extra = own.filter(function (li) { return !attrOf(li) && !seen[keyOf(li)]; }).map(function (li, i) { return { li: li, at: { type: 'zz' }, r: 99, i: 1000 + i }; });
    var all = ranked.concat(extra);
    build(all);
  }).catch(function () { /* Netzfehler: Seite bleibt wie vom Server geliefert */ });

  function build(all) {
    var first = grids[0], second = grids[1], split = parseInt(root.getAttribute('data-split') || '8', 10);
    var restSec = root.querySelector('[data-fr-rf-rest]');
    var restCount = root.querySelector('[data-fr-rf-rest-count]');
    if (sortLbl) sortLbl.textContent = 'Sortiert nach: Routine-Finder-Empfehlung';
    showHint('Wie im Routine-Finder: Die Produkte sind danach sortiert, wie gut sie bei ' + pageTitle.trim() + ' wirken – das beste zuerst. Dieselbe Bewertung wie in deiner Hautanalyse.');
    /* Filterleiste: Marke + Produktart + Sortierung, alles ohne Neuladen */
    var bar = root.querySelector('[data-fr-filter-form]');
    var state = { brand: '', type: '', sort: 'rf' };
    if (bar) {
      var brands = [], types = [];
      all.forEach(function (x) {
        var b = x.li.getAttribute('data-vendor'); if (b && brands.indexOf(b) < 0) brands.push(b);
        if (x.at.type !== 'zz' && TYPE_LABEL[x.at.type] && types.indexOf(x.at.type) < 0) types.push(x.at.type);
      });
      types.sort(function (a, b) { return ORDER.indexOf(a) - ORDER.indexOf(b); });
      var h = '<span class="fr-s-count"><b data-fr-rf-count>' + all.length + '</b> Produkte</span>';
      h += sel('brand', 'Marke', [['', 'Alle Marken']].concat(brands.map(function (b) { return [b, b]; })));
      h += sel('type', 'Produktart', [['', 'Alle Produktarten']].concat(types.map(function (t) { return [t, TYPE_LABEL[t]]; })));
      h += '<label class="fr-s-sort fr-rf-sort"><span class="fr-s-sr">Sortieren</span><select data-fr-rf-f="sort"><option value="rf">Empfehlung (Routine-Finder)</option><option value="pa">Preis aufsteigend</option><option value="pd">Preis absteigend</option></select></label>';
      bar.innerHTML = h;
      bar.removeAttribute('action');
      bar.addEventListener('submit', function (e) { e.preventDefault(); });
      bar.addEventListener('change', function (e) {
        var k = e.target.getAttribute('data-fr-rf-f'); if (!k) return;
        state[k] = e.target.value; render();
      });
      countEl = bar.querySelector('[data-fr-rf-count]');
    }
    function sel(k, label, opts) {
      return '<label class="fr-rf-sel"><span class="fr-s-sr">' + label + '</span><select data-fr-rf-f="' + k + '">' +
        opts.map(function (o) { return '<option value="' + esc(o[0]) + '">' + esc(o[1]) + '</option>'; }).join('') + '</select></label>';
    }
    function render() {
      var list = all.filter(function (x) {
        return (!state.brand || x.li.getAttribute('data-vendor') === state.brand) && (!state.type || x.at.type === state.type);
      });
      if (state.sort !== 'rf') {
        var dir = state.sort === 'pa' ? 1 : -1;
        list = list.slice().sort(function (a, b) { return dir * ((+a.li.getAttribute('data-price') || 0) - (+b.li.getAttribute('data-price') || 0)); });
      }
      [first, second].forEach(function (g) { if (g) g.innerHTML = ''; });
      list.forEach(function (x, k) { ((k < split || !second) ? first : second).appendChild(x.li); });
      if (restSec) restSec.hidden = list.length <= split;
      if (restCount) restCount.textContent = Math.max(0, list.length - split) + ' weitere';
      if (countEl) countEl.textContent = list.length;
      if (sortLbl) sortLbl.hidden = state.sort !== 'rf';
      hint.hidden = state.sort !== 'rf';
    }
    render();
    root.classList.add('is-rf');
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
});
